module.exports = "/images/register_bg.jpg?f009008fa47f8a588c97b6cb90710ca1";